import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { ArrowRight, Star } from 'lucide-react';

const journeys = [
  { name: "Amruta's Journey", loss: '-5kg', duration: 'in 3 months', tag: 'Sustainable' },
  { name: "Kavya's PCOS Reset", loss: '-8kg', duration: 'in 4 months', tag: 'Regular cycles' },
  { name: "Rohit's Fat Loss", loss: '-12kg', duration: 'in 5 months', tag: 'Zero cravings' },
  { name: "Shruti + Partner", loss: '-15kg total', duration: 'in 3 months', tag: 'Couple plan' },
  { name: "Meena's Reversal", loss: 'HbA1c 8.2 → 6.1', duration: 'in 6 months', tag: 'Diabetes' },
];

const JourneysCard = () => {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % journeys.length), 3200);
    return () => clearInterval(t);
  }, []);
  const j = journeys[idx];
  return (
    <div className="absolute -left-6 bottom-10 bg-white rounded-2xl shadow-xl p-5 w-72 overflow-hidden">
      <div className="flex items-center gap-4">
        <div className="w-12 h-12 rounded-full bg-[#e8f2e2] flex items-center justify-center flex-shrink-0">
          <span className="font-serif text-sm text-[#3a5a2c] leading-none text-center">{j.loss}</span>
        </div>
        <div className="min-w-0">
          <div className="font-medium text-[#1a2b17] text-sm truncate">{j.name}</div>
          <div className="text-xs text-[#7a8471]">{j.duration} · {j.tag}</div>
        </div>
      </div>
      <div className="mt-3 flex gap-1">
        {journeys.map((_, i) => (
          <div key={i} className={`h-1 rounded-full flex-1 transition-all ${i === idx ? 'bg-[#c9743a]' : 'bg-neutral-200'}`} />
        ))}
      </div>
    </div>
  );
};

const Hero = ({ onBook }) => {
  return (
    <section className="relative pt-32 lg:pt-36 pb-24 overflow-hidden bg-[#faf7f1]">
      <div className="absolute -top-40 -right-40 w-[500px] h-[500px] rounded-full bg-[#e8f2e2] opacity-60 blur-3xl" />
      <div className="absolute top-1/2 -left-32 w-[400px] h-[400px] rounded-full bg-[#fce7d5] opacity-50 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/70 backdrop-blur border border-[#e5e0d3] mb-6">
            <span className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-3.5 h-3.5 fill-[#e8a94b] text-[#e8a94b]" />
              ))}
            </span>
            <span className="text-xs text-[#3a4a2c] tracking-wide">Rated 4.9 by 10,000+ clients</span>
          </div>

          <h1 className="font-serif text-5xl lg:text-7xl leading-[1.05] text-[#1a2b17] tracking-tight">
            Personalised <br />
            <span className="italic text-[#c9743a] font-light">Nutrition</span> that
            <br /> actually works
          </h1>
          <p className="mt-7 text-lg text-[#4a5544] max-w-xl leading-relaxed">
            Science-backed diet plans for women and working professionals to boost
            metabolism, balance hormones, manage PCOS and reach long-term goals —
            naturally and sustainably.
          </p>

          <div className="mt-9 flex flex-wrap gap-4">
            <Button
              onClick={onBook}
              className="h-14 px-8 rounded-full bg-[#3a5a2c] hover:bg-[#2d4622] text-white text-base group"
            >
              Book a Free Consultation
              <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
            </Button>
            <Button
              variant="outline"
              onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}
              className="h-14 px-8 rounded-full border-[#1a2b17]/20 text-[#1a2b17] hover:bg-[#1a2b17] hover:text-white bg-transparent"
            >
              Explore Programs
            </Button>
          </div>

          <div className="mt-10 flex items-center gap-5">
            <div className="flex -space-x-3">
              {[
                'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop',
                'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop',
                'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop',
                'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop',
              ].map((src, i) => (
                <img
                  key={i}
                  src={src}
                  className="w-11 h-11 rounded-full border-2 border-[#faf7f1] object-cover"
                  alt="client"
                />
              ))}
            </div>
            <div className="text-sm text-[#4a5544]">
              <div className="font-medium text-[#1a2b17]">10,000+ transformations</div>
              <div>across India, UAE, US &amp; UK</div>
            </div>
          </div>
        </div>

        <div className="relative">
          <div className="absolute inset-0 bg-gradient-to-br from-[#e8f2e2] to-[#fce7d5] rounded-[3rem] rotate-3" />
          <div className="relative rounded-[3rem] overflow-hidden shadow-2xl">
            <img
              src="https://customer-assets-jt897jd0.emergentagent.net/job_prachi-premium/artifacts/tqofaxeh_IMG_9848.JPG.webp"
              alt="Dietitian Prachi"
              className="w-full h-[560px] object-cover object-top"
            />
          </div>
          <JourneysCard />
        </div>
      </div>
    </section>
  );
};

export default Hero;
